import { loaderConstant } from "../constants/loader.constant";

const initialState = {
    loading: false
};

export function loader(state = initialState, action) {
    switch (action.type) {
        case loaderConstant.SHOW_LOADER:
            return {
                ...state,
                loading: true
            };
        case loaderConstant.HIDE_LOADER:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
} 